var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        { attrs: { label: "Thickness" } },
        [
          _c(
            "b-input-group",
            {
              scopedSlots: _vm._u([
                {
                  key: "append",
                  fn: function () {
                    return [
                      _c("b-input", {
                        attrs: { max: 100, min: 0, type: "number" },
                        on: { input: _vm.changeShadow },
                        model: {
                          value: _vm.thickness,
                          callback: function ($$v) {
                            _vm.thickness = $$v
                          },
                          expression: "thickness",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("b-input", {
                attrs: { max: 100, min: 0, type: "range" },
                on: { input: _vm.changeShadow },
                model: {
                  value: _vm.thickness,
                  callback: function ($$v) {
                    _vm.thickness = $$v
                  },
                  expression: "thickness",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Blur" } },
        [
          _c(
            "b-input-group",
            {
              scopedSlots: _vm._u([
                {
                  key: "append",
                  fn: function () {
                    return [
                      _c("b-input", {
                        attrs: { max: 100, min: 0, type: "number" },
                        on: { input: _vm.changeShadow },
                        model: {
                          value: _vm.blur,
                          callback: function ($$v) {
                            _vm.blur = $$v
                          },
                          expression: "blur",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("b-input", {
                attrs: { max: 100, min: 0, type: "range" },
                on: { input: _vm.changeShadow },
                model: {
                  value: _vm.blur,
                  callback: function ($$v) {
                    _vm.blur = $$v
                  },
                  expression: "blur",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Color" } },
        [
          _c("ColorPicker", {
            attrs: { opacity: "", copy: "", position: "right-middle" },
            on: { input: _vm.changeShadow },
            model: {
              value: _vm.color,
              callback: function ($$v) {
                _vm.color = $$v
              },
              expression: "color",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }